module.exports = __webpack_public_path__ + "static/img/ditu.5ba5f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ditu.png
// module id = FDyP
// module chunks = 18